<template>
  <div>
    <viewForm ref="viewForm" :is-edit="false" :user-info="userInfo" :user-all-roles="userAllRoles" is-customer @submit="submit"/>
    <el-dialog
      :title="$t('CustomerFunction.accountCreated')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="40%"
      :before-close="dialogClose">
      <h4>{{$t('CustomerFunction.ClientCode')}} : {{ UserClientCode }}</h4>
      <h4>{{$t('CustomerFunction.Account')}} : {{ UserLoginName }}</h4>
      <h4>{{$t('CustomerFunction.Password')}} : {{ UserPassword }}</h4>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary"
          v-clipboard:copy="`${this.$t('CustomerFunction.ClientCode')} : ${this.UserClientCode} ,${this.$t('CustomerFunction.Account')} : ${this.UserLoginName} ,${this.$t('CustomerFunction.Password')} : ${this.UserPassword}.`" 
          v-clipboard:success="onCopySuccess" 
          @click="handlerConfirm">{{$t('okText')}}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { userApi,funConfigApi } from '@/api';
import viewForm from './components/viewForm';
export default {
  name: 'BusinessUserCustomerAddCSG',
  components: {
    viewForm,
  },
  data() {
    return {
      userInfo: null,
      userAllRoles: [],
      // 用户新增成功后dialog提示框
      dialogVisible: false,
      UserClientCode: null,
      UserLoginName: null,
      UserPassword: null,
    };
  },
  computed: {
    onboardingId() {
      return this.$route.query.onboardingId || '';
    },
  },
  watch: {
    onboardingId: {
      handler(v) {
        if (v) {
          this.getOnboardingData(v);
        }
      },
      immediate: true,
    },
  },
  created() {},
  methods: {
    // 获取入场客户已有数据 ==> 回显页面上
    getOnboardingData(v){
      funConfigApi.getOnboardingUserAdd(v).then(res=>{
        this.userAllRoles = res.memberRoleList.filter(item=> item.roleId).map(item=>{
          return{
            id:item.roleId,
            name:item.roleName
          }
        })

        const result = {};
        for (const key in res) {
            const value = res[key];
            if (value === null || Array.isArray(value)) {
                continue;
            }
            result[key] = value;
        }
        this.userInfo = result
        // console.log(this.userInfo,'this.userInfo');
        // console.log(this.userAllRoles,'this.userAllRoles');
      })
    },
    // 客户新增
    submit(data) {
      let ADD_DATA = {}
      // 入场客户 新增客户
      if(this.$route.query.onboardingId){
        ADD_DATA = {
          ...data,
          // 马光浩 2025/1/21
          deptAbbr:'AAA',
          onboardingId:this.$route.query.onboardingId
        }
        // 判断添加的是用户还是客户
        userApi['createCustomerOnboarding'](ADD_DATA).then(res => {
          if (res.realName) {
            this.UserClientCode = res.customerInfo.clientCode
            this.UserLoginName = res.loginName
            this.UserPassword = ADD_DATA.password
            this.dialogVisible = true
          }
        });
      }else{
        // 普通 新增客户
        ADD_DATA = {
          ...data,
          // 马光浩 2025/1/21
          deptAbbr:'AAA'
        }
        // 判断添加的是用户还是客户
        userApi['createCustomer'](ADD_DATA).then(res => {
          if (res.realName) {
            const msg = ` ${res.realName} ${this.$t('toast.login')} ${res.loginName}`;
            this.$alert(msg, this.$t('toast.operationSuccessText'), {
              confirmButtonText: this.$t('toast.okText'),
              callback: () => {
                this.$refs.viewForm.complete({ name: 'BusinessUserCustomerCSG' });
              },
            });
          }
        });
      }
    },
    // 用户新增成功后dialog提示框： 关闭
    dialogClose(){
      this.dialogVisible = false
    },
    // 复制成功提示语
    onCopySuccess(){
      this.$message.success(this.$t('CustomerFunction.accountCreatedText'));
    },
    // 用户新增成功后dialog提示框：完成后关闭并跳转页面
    handlerConfirm(){
      this.dialogVisible = false
      setTimeout(() => {
        this.$refs.viewForm.complete({ name: 'onboardingPageIndex' })
      }, 1000);
    },
  },
};
</script>
